import { useCallback } from 'react';
import PropTypes from 'prop-types';

import { Popups } from 'src/lib/popups';
import { useUiActions } from 'src/store';

const propTypes = {
  children: PropTypes.node.isRequired,
};

export const PopupService = ({ children }) => {
  const uiActions = useUiActions();

  const handlePopupStackChange = useCallback(
    (popupStack) => {
      const popupCount = popupStack?.length || 0;
      uiActions.setGlobalPopupVisibleCount(popupCount);
    },
    [uiActions]
  );

  return <Popups onPopupStackChange={handlePopupStackChange}>{children}</Popups>;
};

PopupService.displayName = 'PopupService';
PopupService.propTypes = propTypes;
